import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fmtNum } from "@finance/lib/api";
import Layout, { PageHeader } from "@finance/components/Layout";
import { Button } from "@finance/components/ui/button";

export default function ItemHistory() {
  const { sku } = useParams();
  const [d, setD] = useState(null);
  const [f, setF] = useState({ date_from: "", date_to: "" });
  const params = { date_from: f.date_from || undefined, date_to: f.date_to || undefined };
  const load = useCallback(() => api.get(`/inventory/items/${encodeURIComponent(sku)}/history`, { params }).then((r) => setD(r.data)), [sku, f]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [sku]); // eslint-disable-line react-hooks/exhaustive-deps
  const csv = async () => {
    const r = await api.get(`/inventory/items/${encodeURIComponent(sku)}/history`, { params: { ...params, fmt: "csv" }, responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `${sku}-history.csv`; a.click();
  };
  const inp = "h-8 rounded-sm border border-gray-300 px-2 text-sm";
  return (
    <Layout>
      <PageHeader title={d ? `${d.item.name || sku}` : sku} subtitle={`Movement history · ${sku}`} actions={<Link to="/inventory" className="text-sm text-[#1B4383] hover:underline" data-testid="item-history-back">← Inventory</Link>} />
      <div className="mx-8 my-6 space-y-4" data-testid="item-history">
        {d && (
          <div className="grid grid-cols-3 gap-4">
            <div className="rounded-sm border border-gray-200 bg-white p-4"><div className="lx-label text-gray-500">On hand</div><div className="lx-num text-xl font-semibold" data-testid="ih-onhand">{fmtNum(d.on_hand)}</div></div>
            <div className="rounded-sm border border-gray-200 bg-white p-4"><div className="lx-label text-gray-500">AVCO unit cost</div><div className="lx-num text-xl font-semibold">TZS {fmtNum(d.avg_cost)}</div></div>
            <div className="rounded-sm border border-gray-200 bg-white p-4"><div className="lx-label text-gray-500">Value</div><div className="lx-num text-xl font-semibold" data-testid="ih-value">TZS {fmtNum(d.value)}</div></div>
          </div>
        )}
        <div className="flex flex-wrap items-center gap-2">
          <input type="date" className={inp} data-testid="ih-from" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} />
          <input type="date" className={inp} data-testid="ih-to" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} />
          <Button size="sm" variant="outline" data-testid="ih-apply" onClick={load}>Apply</Button>
          <Button size="sm" variant="outline" data-testid="ih-csv" onClick={csv}>Export CSV</Button>
          <Button size="sm" variant="outline" data-testid="ih-pdf" onClick={() => window.print()}>Print / PDF</Button>
        </div>
        <div className="overflow-x-auto rounded-sm border border-gray-200 bg-white">
          <table className="w-full text-sm">
            <thead className="bg-gray-50"><tr className="lx-label border-b border-gray-200"><th className="px-4 py-2 text-left">Date</th><th className="px-4 py-2 text-left">Type</th><th className="px-4 py-2 text-left">Record</th><th className="px-4 py-2 text-right">In</th><th className="px-4 py-2 text-right">Out</th><th className="px-4 py-2 text-right">Balance</th></tr></thead>
            <tbody>
              {(d?.rows || []).map((r, i) => (
                <tr key={i} className="border-b border-gray-100" data-testid={`ih-row-${i}`}>
                  <td className="px-4 py-2 lx-num">{r.date}</td><td className="px-4 py-2">{(r.type || "").replace(/_/g, " ")}</td>
                  <td className="px-4 py-2">{r.transaction_id ? <Link className="text-[#1B4383] hover:underline" to={`/transactions?open=${r.transaction_id}`}>{r.po || "PO"}</Link> : (r.note || "—")}</td>
                  <td className="px-4 py-2 text-right lx-num">{r.qty_in ? fmtNum(r.qty_in) : ""}</td><td className="px-4 py-2 text-right lx-num">{r.qty_out ? fmtNum(r.qty_out) : ""}</td>
                  <td className="px-4 py-2 text-right lx-num">{fmtNum(r.balance)}</td>
                </tr>
              ))}
              {d && !d.rows.length && <tr><td colSpan={6} className="px-4 py-6 text-center text-gray-400">No movements.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
